import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '商品名称',
      placeholder: '请输入商品名称',
      rules: {required: true, message: '商品名称是必传的', trigger: 'blur'}
    },
    {
      field: 'monthPrice',
      type: 'number',
      label: '1个月价格',
      placeholder: '请输入1个月价格'
    },
    {
      field: 'twoMonthPrice',
      type: 'number',
      label: '2个月价格',
      placeholder: '请输入2个月价格'
    },
    {
      field: 'threeMonthPrice',
      type: 'number',
      label: '季度价格',
      placeholder: '请输入季度价格'
    },
    {
      field: 'fourMonthPrice',
      type: 'number',
      label: '4个月价格',
      placeholder: '请输入4个月价格'
    },
    {
      field: 'fiveMonthPrice',
      type: 'number',
      label: '5个月价格',
      placeholder: '请输入5个月价格'
    },
    {
      field: 'sixMonthPrice',
      type: 'number',
      label: '半年价格',
      placeholder: '请输入半年价格'
    },
    {
      field: 'yearPrice',
      type: 'number',
      label: '年度价格',
      placeholder: '请输入年度价格'
    },
    {
      field: 'deposit',
      type: 'number',
      label: '定金',
      placeholder: '请输入定金'
    },
    // {
    //   field: 'initSellNum',
    //   type: 'number',
    //   label: '初始已售卖量',
    //   placeholder: '请输入已售卖量'
    // },
    {
      field: 'buyLink',
      type: 'input',
      label: '商品链接',
      placeholder: '请输入商品链接',
      rules: {required: true, message: '商品链接是必传的', trigger: 'blur'}
    },
    {
      field: 'liveRoom',
      type: 'select',
      label: '所属直播间',
      placeholder: '请选择直播间',
      rules: {required: true, message: '直播间是必选的', trigger: 'blur'}
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
